import { GlobalStatus, JobCompletedEnum, OperationTypeEnum, ShiftsEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
export class AssignSoakingDto{
    lotNumber: string;
    subLotNumber: string;
    saleOrderId: number;
    saleOrderItemId?: number;
    operation: OperationTypeEnum;
    nextOperation: OperationTypeEnum;
    physicalQuantity: number;
    issuedQuantity: number;
    intransitQuantity?: number;
    wipQuantity?: number;
    wastageQuantity?: number;
    rejectedQuantity?: number;
    inputGrade: number;
    outputGrade: number;
    boxes: number;
    ipBoxes: number;
    soakingStyle: string;
    soakingTime: string;
    opBoxes: number;
    shift: ShiftsEnum;
    workStationType: WorkStationTypeEnum;
    workstation: number;
    weighmentReq: GlobalStatus;
    plantId?: number;
    assignedTime?: Date
    subPlantId?: number;
    productionInventoryId?: number;
    createdUser: string;
    updatedUser: string;
    constructor(
        lotNumber: string,
        subLotNumber: string,
        saleOrderId: number,
        operation: OperationTypeEnum,
        nextOperation: OperationTypeEnum,
        physicalQuantity: number,
        issuedQuantity: number,
        inputGrade: number,
        outputGrade: number,
        boxes: number,
        ipBoxes: number,
        soakingStyle: string,
        soakingTime: string,
        opBoxes: number,
        shift: ShiftsEnum,
        workStationType: WorkStationTypeEnum,
        workstation: number,
        weighmentReq: GlobalStatus,
        createdUser: string,
        updatedUser: string,
        saleOrderItemId?: number,
        intransitQuantity?: number,
        wipQuantity?: number,
        wastageQuantity?: number,
        rejectedQuantity?: number,
        plantId?: number,
        assignedTime?: Date,
        subPlantId?: number,productionInventoryId?:number){
            this.lotNumber= lotNumber,
            this.subLotNumber= subLotNumber,
            this.saleOrderId= saleOrderId,
            this.operation= operation,
            this.nextOperation= nextOperation,
            this.physicalQuantity= physicalQuantity,
            this.issuedQuantity= issuedQuantity,
            this.inputGrade= inputGrade,
            this.outputGrade= outputGrade,
            this.boxes= boxes,
            this.ipBoxes= ipBoxes,
            this.soakingStyle= soakingStyle,
            this.soakingTime= soakingTime,
            this.opBoxes= opBoxes,
            this.shift= shift,
            this.workStationType= workStationType,
            this.workstation= workstation,
            this.weighmentReq= weighmentReq,
            this.createdUser= createdUser,
            this.updatedUser= updatedUser,
            this.saleOrderItemId= saleOrderItemId,
            this.intransitQuantity= intransitQuantity,
            this.wipQuantity= wipQuantity,
            this.wastageQuantity= wastageQuantity,
            this.rejectedQuantity= rejectedQuantity,
            this.plantId= plantId,
            this.assignedTime= assignedTime,
            this.subPlantId= subPlantId
            this.productionInventoryId= productionInventoryId
    }
}